"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorCollectionFieldView = exports.CSS = void 0;
const tslib_1 = require("tslib");
const IkeModel = tslib_1.__importStar(require("@ikegps/core-shared"));
const core_shared_1 = require("@ikegps/core-shared");
const collection_title_1 = require("../../../components/collection/collection.title");
const input_1 = require("../../../components/input/input");
const spinner_1 = require("../../../components/spinner/spinner");
const theme_1 = require("../../../components/theme");
const index_1 = require("../../../i18n/index");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const page_state_1 = require("../../../state/page.state");
const store_1 = require("../../../store");
const capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
const field_info_1 = require("../../field.info/field.info");
exports.CSS = {
    capture: 'c-Vector__capture'
};
(0, theme_1.addStyles)({
    [exports.CSS.capture]: {
        padding: theme_1.DefaultTheme.space(1)
    }
});
function viewTopLevelCaptures(collection) {
    const imageCtx = { truesize: true, className: exports.CSS.capture };
    const nodes = [];
    for (const formField of collection.schema.fields) {
        const field = collection.getField(formField.id);
        if (!IkeModel.CollectionModelFieldTrueSize.isTrueSizeField(field) || !field.hasValue()) {
            continue;
        }
        const captures = field.getCaptures();
        for (const capture of captures) {
            imageCtx.title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
            nodes.push(capture_thumbnail_1.CaptureThumbnail.view(collection, capture, imageCtx));
        }
    }
    return nodes;
}
exports.VectorCollectionFieldView = {
    viewInline(field, ctrl) {
        const targetCollections = field.getCollections();
        if (targetCollections == null || targetCollections[0] == null) {
            return (0, mithril_1.m)('span', (0, index_1.Translate)(index_1.T.UNKNOWN));
        }
        const targetCollection = store_1.AppStore.CollectionSummary.getLatest(targetCollections[0].revision) || targetCollections[0];
        let titleNode;
        let vectorValue = field.value;
        if (ctrl.canInspectCollection(targetCollection)) {
            titleNode = (0, mithril_1.m)('a', {
                title: (0, index_1.Translate)(index_1.T.COLLECTION_EDIT),
                onclick: () => {
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'vector:link:navigate', field.schema.displayName, 1);
                    ctrl.inspectCollection(targetCollection.revision);
                }
            }, collection_title_1.CollectionTitle.view(targetCollection.title));
            vectorValue = core_shared_1.IkeGeodesic.getVector(field.collection.location, store_1.AppStore.Collection.get(targetCollection.revision).location);
        }
        else {
            titleNode = collection_title_1.CollectionTitle.view(targetCollection.title);
        }
        const onmouseover = () => {
            page_state_1.CurrentState.setHoverId(field.id);
        };
        const onmouseout = () => {
            page_state_1.CurrentState.setHoverId(null);
        };
        const className = input_1.Input.CSS.container;
        return (0, mithril_1.m)('div', { className, onmouseover, onmouseout, onclick }, [
            (0, mithril_1.m)('span', [
                field_info_1.FieldInfo.viewVectorInline(vectorValue),
                ' - ',
                titleNode
            ])
        ]);
    },
    hasDetail(field) {
        return true;
    },
    viewDetail(field) {
        const targetCollections = field.getCollections();
        if (targetCollections == null || targetCollections[0] == null) {
            return null;
        }
        const targetCollection = targetCollections[0];
        const targetCollectionModel = store_1.AppStore.Collection.get(targetCollection.revision);
        if (targetCollectionModel == null) {
            return spinner_1.Spinner.view();
        }
        const captureNodes = viewTopLevelCaptures(targetCollectionModel);
        if (captureNodes.length === 0) {
            return (0, mithril_1.m)('span', (0, index_1.Translate)(index_1.T.NO_CAPTURES));
        }
        return mithril_1.m.fragment({}, captureNodes);
    },
    viewEdit(field, ctrl) {
        return exports.VectorCollectionFieldView.viewInline(field, ctrl);
    }
};
//# sourceMappingURL=vector.collection.field.view.js.map